/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import {translate} from '@ion/core/src/locale/locale';
import {JobTask} from '@ion/core/src/types/entities';

export const getJobStatus = (tasks = []) => {
  const na = translate('common:notAvailable');
  const deviceCount = tasks?.[0]?.task?.counts?.total;

  return translate('downloadjobs:grid.itemCount', {
    taskCount   : tasks?.length ?? na,
    deviceCount : deviceCount ?? na
  });
};

/**
 * Gets the task order based on the provided isLookup value.
 * It returns the order value decreased by one if the isLookup value is true; otherwise,
 * it returns the exact order value.
 */
export const getTaskOrder = (item: JobTask, isLookup = true): number => {
  const order = item?.data?.taskOrder;
  return isLookup ? order -1 : order;
};
